<template>
  <div class="about-sr-area">
    <div class="content-inner inner-media-width yd-display-flex yd-justifyContent-s">
      <transition name="fade-left-right" mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
      <!--局部导航-->
      <right-navbar></right-navbar>
    </div>
  </div>
</template>

<script>
  import rightNavbar from './components/rightNavbar'
  export default {
    name: "index",
    components: {rightNavbar}
  }
</script>

<style scoped>
  .about-sr-area{
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 128px;
  }
  .content-inner{
    width: 74%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/joinUs/index.vue